import { useState } from 'react';
import { BookingList } from 'modules/booking';
import styles from './BookingListTable.module.css';
import BookingDetailsPopup from 'pages/kunde/customerBookinkPooup/customerBookingDetailsPopup';
import CancelDetailsPopup from 'pages/kunde/customerBookinkPooup/customerCancelDetailsPopup';

interface BookingTableProps {
    bookings: BookingList[];
    onSort: (key: 'name' | 'age' | 'request_date' | 'date' | 'status') => void;
    sortConfig: { key: keyof BookingList | null; direction: 'asc' | 'desc' };
    isCancel: boolean, onClose: () => void;

}

export default function BookingListTable({ bookings, onSort, sortConfig, isCancel, onClose }: BookingTableProps) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState<BookingList | null>(null);

    const handleRowClick = (booking: BookingList) => {
        setSelectedBooking(booking);
        setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setSelectedBooking(null)
        onClose();
    };

    const sortedBookings = [...bookings].sort((a, b) => {
        if (sortConfig.key) {
            let aValue = a[sortConfig.key];
            let bValue = b[sortConfig.key];

            if (aValue === undefined) return 1;
            if (bValue === undefined) return -1;

            if (
                (sortConfig.key === 'request_date' || sortConfig.key === 'date') &&
                typeof aValue === 'string' &&
                typeof bValue === 'string'
            ) {
                const aDate = new Date(aValue.split('.').reverse().join('-'));
                const bDate = new Date(bValue.split('.').reverse().join('-'));

                return sortConfig.direction === 'asc' ? aDate.getTime() - bDate.getTime() : bDate.getTime() - aDate.getTime();
            } else {
                return sortConfig.direction === 'asc' ? (aValue < bValue ? -1 : 1) : (aValue > bValue ? -1 : 1);
            }
        }
        return 0;
    });

    return (
        <div className={styles.tbodyContainer}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th onClick={() => onSort('name')}>
                            Name {sortConfig.key === 'name' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th onClick={() => onSort('age')}>
                            Alter {sortConfig.key === 'age' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th onClick={() => onSort('request_date')}>
                            Anfrage am {sortConfig.key === 'request_date' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th onClick={() => onSort('date')}>
                            Anfrage für {sortConfig.key === 'date' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                        <th className={styles.thStatus}
                            onClick={() => onSort('status')}>
                            Status {sortConfig.key === 'status' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {sortedBookings.map((booking, index) => (
                        <tr key={index} onClick={() => handleRowClick(booking)} className={styles.clickableRow}>
                            <td className={styles.tdNameCountainer}>{booking.name}</td>
                            <td>{booking.age} J.</td>
                            <td>{booking.request_date?.toString()}</td>
                            <td>{booking.date?.toString()}</td>
                            <td className={styles.tdStatus}>
                                <span className={`${styles.status} ${styles[booking.status.split('(')[0].trim()]}`}>
                                    <span className={styles.mainStatus}>
                                        {booking.status.split('(')[0].trim()}
                                    </span>

                                    {booking.status.includes('(') && (
                                        <span className={styles.subStatus}>
                                            {booking.status.split('(')[1].replace(')', '').trim()}
                                        </span>
                                    )}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {selectedBooking && (
                !isCancel ? (
                    <BookingDetailsPopup
                        isOpen={isPopupOpen}
                        onClose={handleClosePopup}
                        bookinglist={selectedBooking}
                    />
                ) : (
                    <CancelDetailsPopup
                        isOpen={isPopupOpen}
                        onClose={handleClosePopup}
                        bookinglist={selectedBooking}
                    />
                )
            )}

        </div>
    );
}
